const RI_TO_TI_EXACT: Record<string, string> = {
    "ri-home-5-line": "home",
    "ri-home-5-fill": "home-filled",
    "ri-clipboard-line": "clipboard-text",
    "ri-clipboard-fill": "clipboard-text",
    "ri-truck-line": "truck",
    "ri-truck-fill": "truck",
    "ri-shield-check-line": "shield-check",
    "ri-shield-check-fill": "shield-check-filled",
    "ri-delete-bin-6-line": "trash",
    "ri-delete-bin-6-fill": "trash-filled",
    "ri-delete-bin-line": "trash",
    "ri-arrow-left-line": "arrow-left",
    "ri-arrow-right-line": "arrow-right",
    "ri-arrow-left-s-line": "chevron-left",
    "ri-arrow-right-s-line": "chevron-right",
    "ri-arrow-up-s-line": "chevron-up",
    "ri-arrow-down-s-line": "chevron-down",
    "ri-arrow-down-line": "arrow-down",
    "ri-calendar-line": "calendar",
    "ri-calendar-check-line": "calendar-check",
    "ri-calendar-2-line": "calendar-month",
    "ri-calendar-event-line": "calendar-event",
    "ri-user-line": "user",
    "ri-user-3-line": "user",
    "ri-user-settings-line": "user-cog",
    "ri-store-2-line": "building-store",
    "ri-shopping-cart-2-line": "shopping-cart",
    "ri-shopping-cart-2-fill": "shopping-cart-filled",
    "ri-shopping-cart-line": "shopping-cart",
    "ri-shopping-basket-line": "basket",
    "ri-shopping-basket-2-line": "basket",
    // Ba việc của máy cầm tay trong kho.
    "ri-archive-drawer-line": "archive",
    "ri-swap-box-line": "arrows-exchange",
    "ri-qr-scan-2-line": "scan",
    "ri-barcode-line": "barcode",
    "ri-loader-4-line": "loader-2",
    "ri-checkbox-circle-line": "circle-check",
    "ri-check-line": "check",
    "ri-close-line": "x",
    "ri-close-circle-fill": "circle-x-filled",
    "ri-error-warning-line": "alert-triangle",
    "ri-error-warning-fill": "alert-triangle-filled",
    "ri-information-line": "info-circle",
    "ri-lock-line": "lock",
    "ri-lock-2-line": "lock",
    "ri-lock-password-line": "lock-password",
    "ri-message-2-line": "message",
    "ri-shield-keyhole-line": "shield-lock",
    "ri-eye-line": "eye",
    "ri-eye-off-line": "eye-off",
    "ri-search-line": "search",
    "ri-menu-line": "menu-2",
    "ri-camera-line": "camera",
    "ri-image-line": "photo",
    "ri-image-2-line": "photo",
    "ri-add-line": "plus",
    "ri-add-circle-line": "circle-plus",
    "ri-file-list-line": "clipboard-text",
    "ri-file-list-3-line": "clipboard-text",
    "ri-file-text-line": "file-text",
    "ri-file-damage-line": "file-alert",
    "ri-map-pin-2-line": "map-pin",
    "ri-price-tag-3-line": "tag",
    "ri-history-line": "history",
    "ri-edit-line": "edit",
    "ri-filter-3-line": "filter",
    "ri-draft-line": "file-pencil",
    "ri-inbox-line": "inbox",
    "ri-box-3-line": "package",
    "ri-building-line": "building",
    "ri-bar-chart-2-line": "chart-bar",
    "ri-logout-box-r-line": "logout-2",
    "ri-time-line": "clock",
};

function mapRiToTi(riClass: string): string {
    const exact = RI_TO_TI_EXACT[riClass];

    if (exact) {
        return exact;
    }

    const base = riClass.replace(/^ri-/, "").replace(/-(line|fill)$/i, "");

    if (base.includes("arrow-left")) return "arrow-left";
    if (base.includes("arrow-right")) return "arrow-right";
    if (base.includes("arrow-up")) return "arrow-up";
    if (base.includes("arrow-down")) return "arrow-down";
    if (base.includes("calendar")) return "calendar";
    if (base.includes("shopping-cart")) return "shopping-cart";
    if (base.includes("shopping")) return "basket";
    if (base.includes("delete") || base.includes("trash")) return "trash";
    if (base.includes("warning") || base.includes("alert")) return "alert-triangle";
    if (base.includes("information") || base.includes("info")) return "info-circle";
    if (base.includes("lock")) return "lock";
    if (base.includes("user")) return "user";
    if (base.includes("store") || base.includes("building")) return "building-store";
    if (base.includes("search")) return "search";
    if (base.includes("check")) return "check";
    if (base.includes("close")) return "x";
    if (base.includes("menu")) return "menu-2";
    if (base.includes("loader")) return "loader-2";
    if (base.includes("camera")) return "camera";
    if (base.includes("image") || base.includes("photo")) return "photo";
    if (base.includes("file")) return "file";
    if (base.includes("chart")) return "chart-bar";

    return "circle";
}

function remapIconElement(element: HTMLElement): void {
    const classes = Array.from(element.classList);
    const riClass = classes.find((className) => className.startsWith("ri-"));

    if (!riClass) {
        return;
    }

    const tiIconName = mapRiToTi(riClass);

    classes
        .filter((className) => className === "ti" || className.startsWith("ti-"))
        .forEach((className) => element.classList.remove(className));

    element.classList.remove(riClass);
    element.classList.add("ti", `ti-${tiIconName}`);
    element.setAttribute("data-icon-library", "tabler");
}

function remapIconsIn(root: ParentNode): void {
    root.querySelectorAll("i[class*='ri-']").forEach((node) => {
        remapIconElement(node as HTMLElement);
    });
}

let isInitialized = false;

export function initRemixToTablerMapper(): void {
    if (isInitialized || typeof window === "undefined") {
        return;
    }

    isInitialized = true;

    const run = () => remapIconsIn(document);
    run();

    const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            if (mutation.type === "attributes") {
                const target = mutation.target as HTMLElement;

                if (target.tagName === "I" && target.className.includes("ri-")) {
                    remapIconElement(target);
                }

                continue;
            }

            mutation.addedNodes.forEach((node) => {
                if (!(node instanceof HTMLElement)) {
                    return;
                }

                if (node.tagName === "I" && node.className.includes("ri-")) {
                    remapIconElement(node);
                }

                remapIconsIn(node);
            });
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["class"],
    });
}
